









import Sidebar from "../components/Sidebar2.vue";
import Navbar from "../components/Navbar.vue";

import Vue from "vue";
export default Vue.extend({
  components: {
    Sidebar,
    Navbar
  }
});
